import React from 'react';
import classnames from 'classnames';
import { Icon } from 'tea-component';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import {
  analysisPlatformTopInfo,
  getStoreRankTopName,
} from '@/pages/intelligence/_config/storeRank/utils';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import SvgIcon from '@/pages/home/components/SvgIcon';

interface IMetricsSourceProps extends IBaseProps {
  entityType: IGameType;
  dataSource: string;
}

const MetricsSource: React.FC<IMetricsSourceProps> = (props) => {
  const { style, className, entityType, dataSource } = props;

  const { formatMessage } = useIntlExtend();
  const { platform, top } = analysisPlatformTopInfo(dataSource);

  return (
    <div key={dataSource} style={style} className={className}>
      <img
        src={getDataSourceIcon(platform)}
        className="dbi-metric-table__table-datasorce"
      />
      <span className="dbi-compare-mobile-text">
        {getStoreRankTopName(entityType as any, top, formatMessage)}
      </span>
    </div>
  );
};

interface IStroeRankItemProps extends IBaseProps {
  value: string;
  dod: number;
}

const StroeRankItem: React.FC<IStroeRankItemProps> = (props) => {
  const { value, dod } = props;

  const { formatMessage } = useIntlExtend();

  const getWoWText = (dod: any): string => {
    return formatMessage({ id: 'dbi_compare_mobile_wow' }, { num: dod }) as string;
  };

  const getNoText = (no: any): string => {
    return formatMessage({ id: 'dbi_compare_mobile_no' }, { num: no }) as string;
  };

  const getDod = (dod: number) => {
    if (dod > 0) {
      return {
        val: (
          <>
            {getWoWText(dod)}
            <SvgIcon className='dbi-icon-style' type="green-up-new" />
          </>
        ),
        color: 'green',
      };
    }
    if (dod < 0) {
      return {
        val: (
          <>
            {getWoWText(Math.abs(dod))}
            <SvgIcon className='dbi-icon-style' type="red-down-new" />
          </>
        ),
        color: 'red',
      };
    }
    if (dod === 0) {
      return {
        val: <>{getWoWText('-')}</>, // 排名没变化为 WoW -
        color: 'red',
      };
    }
    return {
      val: <>-</>, // 没有排名数据为 -
      color: 'grey',
    };
  };

  const dodInfo = getDod(dod);
  const dodColor = dodInfo?.color;
  const dodColorClassName = `dbi-storerank-table__${dodColor}`;
  const dodVal = dodInfo?.val;

  if (Math.abs(dod) > 99) {
    // 超出3位放不下的情况
    return (
      <div className="dbi-storerank-table__item">
        <div className="dbi-storerank-table__value4">
          {parseFloat(value) > 0 ? getNoText(value) : '-'}
        </div>
        <div className="dbi-storerank-table__magin"></div>
        <div
          className={classnames('dbi-storerank-table__dod6', dodColorClassName)}
        >
          {dodVal}
        </div>
      </div>
    );
  }
  return (
    <div className="dbi-storerank-table__item">
      <div className="dbi-storerank-table__value">
        {parseFloat(value) > 0 ? getNoText(value) : '-'}
      </div>
      <div className="dbi-storerank-table__magin"></div>
      <div
        className={classnames('dbi-storerank-table__dod', dodColorClassName)}
      >
        {dodVal}
      </div>
    </div>
  );
};

interface IStoreRankMetricTableProps extends IBaseProps {
  entityType: IGameType;
  MAXGAMENUM: number;
  showHeatMap: boolean;
  dataSource: string[];
  list: any[];
}

const StoreRankMetricTable: React.FC<IStoreRankMetricTableProps> = (props) => {
  const { entityType, list, MAXGAMENUM, showHeatMap, dataSource } = props;

  if (!Array.isArray(list)) {
    return null;
  }

  return (
    <div className="dbi-flex-table dbi-metric-table">
      <div className=" dbi-table-first-colums dbi-table-first-colums">
        {dataSource?.map((item) => (
          <MetricsSource
            className="dbi-table-list-item dbi-metric-table__h3"
            entityType={entityType}
            dataSource={item}
          />
        ))}
      </div>

      {list?.map((item) => (
        <div
          key={item?.game_id}
          className="dbi-flex-table__table-content dbi-metric-table__table-content"
        >
          {dataSource?.map((t) => {
            const periodList = item?.rank_list;
            const period = periodList?.filter(
              (it: any) => it?.source === t,
            )?.[0];
            return (
              <div
                className={classnames('dbi-table-list-item', {
                  'dbi-table-list-item-heatmap':
                    showHeatMap &&
                    (list?.length === 1 || period?.isMax) &&
                    period?.value,
                })}
              >
                <div key={period?.source} className="dbi-table-list-item__text">
                  <StroeRankItem
                    value={period?.value || '-'}
                    dod={period?.dod}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ))}
      {/* {list?.length < MAXGAMENUM && (
        <div className="dbi-flex-table__table-content dbi-metric-table__table-content">
          {dataSource?.map((item: any, i: number) => (
            <div key={i} className="dbi-table-list-item"></div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default StoreRankMetricTable;
